import { Autocomplete, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { IContentFieldProps } from 'types/fields';

interface IIdPInputSingleSelectProps extends IContentFieldProps {
	options: string[];
}

const IdPInputSingleSelect: React.FC<IIdPInputSingleSelectProps> = ({
	disabled,
	displayName,
	name,
	onChange,
	required,
	value,
	options,
	error
}) => {
	const handleChange = useCallback(
		(e: any, newValue: string | null) => {
			/* istanbul ignore next: could not test this */
			onChange(newValue || '');
		},
		[onChange]
	);

	return (
		<Autocomplete
			data-testid="field-single-select"
			size="small"
			disabled={disabled}
			options={options}
			value={value as string}
			onChange={handleChange}
			renderInput={(params) => (
				<TextField
					{...params}
					slotProps={{
						inputLabel: { shrink: true }
					}}
					name={name}
					required={required}
					label={displayName}
					error={Boolean(error)}
					helperText={error}
				/>
			)}
		/>
	);
};

export default IdPInputSingleSelect;
